module.exports = __webpack_public_path__ + "img/contact-wx.64d36c43.png";